module.exports = __webpack_public_path__ + "img/2H.c75fabe6.jpg";